<template>
  <div class="createOrder-page full-height">
    <!-- 面包屑 -->
    <full-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders/orderList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>地址管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="full" class="message full-height display-col">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('addr.addr2')" name="first" :key="'first'">
            <child1 v-if="isChildUpdate1"></child1>
          </el-tab-pane>
          <el-tab-pane :label="$t('addr.addr3')" name="second" :key="'second'">
            <child2 v-if="isChildUpdate2"></child2>
          </el-tab-pane>
        </el-tabs>
      </div>
    </full-con>
  </div>
</template>

<script>
import inAddress from './InAddress'
import outAddress from './OutAddress'

export default {
  components: {
    child1: inAddress,
    child2: outAddress
  },
  data () {
    return {
      //默认选中
      activeName: 'first',
      isChildUpdate1: true,
      isChildUpdate2: false
    }
  },
  methods: {
    handleClick (tab) {
      if (tab.name === 'first') {
        this.isChildUpdate1 = true
        this.isChildUpdate2 = false
      } else if (tab.name === 'second') {
        this.isChildUpdate1 = false
        this.isChildUpdate2 = true
      }
    }
  },
}
</script>

<style lang="less" scoped>
.el-tab-pane {
  height: 700px;
}
</style>